import http from 'plugins/axios';

export default {
  getRecords(data) {
    return http.get({
      url: '/la/admin/mining/interest/history',
      data
    });
  },
  setcalculate(data) {
    return http.post({
      url: '/la/admin/mining/count',
      data,
      dataType: 'form'
    });
  },
  sendAmount(data) {
    return http.post({
      url: '/la/admin/mining/push',
      data,
      dataType: 'form'
    });
  }
};
